import { render, staticRenderFns } from "./AddEditDialog.vue?vue&type=template&id=c968a91c&scoped=true&"
import script from "./AddEditDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditDialog.vue?vue&type=style&index=0&id=c968a91c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c968a91c",
  null
  
)

export default component.exports